























































import { Vue, Component, Watch, PropSync, Ref, Prop } from 'vue-property-decorator'
import { ProdutoAgrupado, Page, Pageable } from '@/models'
import axios, { CancelTokenSource } from 'axios'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { validate } from 'uuid'
import { FindProdutoUseCase } from '@/usecases'

@Component
export default class SeletorDeProdutosAgrupados extends Vue {
	@Ref() campo!: HTMLInputElement
	@PropSync('value') selecionado?: ProdutoAgrupado | string
	@Prop() tipoProdutoAgrupado!: string | null
	@Prop({ type: Boolean, default: false }) exibirNomeCompleto!: boolean
	
	produtos: ProdutoAgrupado[] = []
	busca: string | null = null
	findProdutoAgrupadoUseCase = new FindProdutoUseCase()
	cancelToken: CancelTokenSource | null = null

	pageable: Pageable = {
		page: 0,
		size: 3,
	}
	pagina: Page<ProdutoAgrupado> | null = null
	carregando = true

	created() {
		this.carregarSelecao()
	}

	extrairId(objeto: ProdutoAgrupado | string): string {
		return typeof objeto === 'object'
			? objeto.id
			: objeto
	}

	async carregarSelecao() {
		if (!this.selecionado) {
			return this.find()
		}
		const busca: string[] = Array.isArray(this.selecionado)
			? (this.selecionado as (string | ProdutoAgrupado)[]).map(this.extrairId)
			: [this.extrairId(this.selecionado)]

		try {
			this.carregando = true

			this.cancelToken = axios.CancelToken.source()
			const axiosConfig = {
				cancelToken: this.cancelToken.token,
			}

			let buscaDeId: any = null
			if (validate(busca[0])) buscaDeId = busca[0]

			const params = {
				ids: buscaDeId,
				busca: buscaDeId ? null : busca[0],
			}

			this.pagina = await this.findProdutoAgrupadoUseCase.findProdutosAgrupados(
				params, axiosConfig);

			this.pagina.content.forEach(ProdutoAgrupado => {
				this.produtos.push(ProdutoAgrupado)
			})
		} catch (error: any) {
			if (axios.isCancel(error)) return
			AlertModule.setError(error)
		} finally {
			this.carregando = false
		}
	}

	async find() {
		if (this.cancelToken) this.cancelToken.cancel()
		try {
			this.carregando = true
			this.cancelToken = axios.CancelToken.source()

			if (this.pageable.page === 0) {
				this.produtos = []
			}

			this.pagina = await this.findProdutoAgrupadoUseCase.findProdutosAgrupados({
				page: this.pageable.page || 0,
				size: this.pageable.size,
				busca: this.busca || undefined,
				tipoProdutoAgrupado: this.tipoProdutoAgrupado != undefined ? this.tipoProdutoAgrupado : undefined,
			}, {
				cancelToken: this.cancelToken.token,
			})

			this.pagina.content.forEach(produto => {
				if (this.produtos.some(({ id }) => produto.id === id)) return
				this.produtos.push(produto)
			})
		} catch (error: any) {
			if (axios.isCancel(error)) return
			this.pagina = null
			AlertModule.setError(error)
		} finally {
			this.carregando = false
		}
	}

	@Watch('busca', { deep: true })
	onChangeBusca(busca: string, buscaAnterior: string) {
		if (busca === buscaAnterior) {
			this.carregando = false
			return
		}
		this.pageable = { ...this.pageable, page: 0 }
		this.find()
	}

	async pageNext() {
		this.pageable.page = !this.pageable.page
			? 1
			: this.pageable.page += 1
		await this.find()
	}

	get carregouTodosOsprodutos() {
		return this.pagina?.last || false
	}

	get noDataMessage() {
		if (this.carregando) {
			return 'Carregando...'
		}
		if (!this.busca) {
			return 'Digite para consultar...'
		}
		return '$vuetify.noDataText'
	}

	focus() {
		this.campo.focus()
	}

	customFilter(item: any, queryText: string) {
		const raw = (queryText || '').toLowerCase().trim()
		if (!raw) return true

		const nome = (item?.nome || '').toLowerCase()

		const docItem = (item?.sku || '').toLowerCase()
		const docItemSomenteNumeros = docItem.replace(/\D/g, '')

		const querySomenteNumeros = raw.replace(/\D/g, '')

		if (nome.includes(raw)) return true

		if (querySomenteNumeros.length > 0) {
			if (docItem.includes(raw)) return true
			if (docItemSomenteNumeros.includes(querySomenteNumeros)) return true
		}

		return false
	}

}
